import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Flame } from 'lucide-react';
import { Button } from '../ui/button';
import { menuHighlights } from '../../data/mock';

const MenuHighlights = () => {
  return (
    <section className="py-24 bg-[#F5F0E8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-wider text-[#C67C4E] uppercase mb-4">
            Our Menu
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-[#1B4332] mb-6">
            Experience Italian Perfection
          </h2>
          <p className="text-lg text-[#636E72] max-w-2xl mx-auto">
            Discover the flavours of Italy. Indulge in the heart of Italy with every bite – 
            authentic flavours, unforgettable experiences.
          </p>
        </div>

        {/* Menu Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {menuHighlights.map((item, index) => (
            <div
              key={item.name}
              className="bg-white rounded-2xl p-6 hover-lift shadow-sm"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex justify-between items-start mb-4">
                <span className="inline-block px-3 py-1 bg-[#1B4332]/10 rounded-full text-sm font-medium text-[#1B4332]">
                  {item.category}
                </span>
                {item.spicy && (
                  <Flame size={20} className="text-[#C67C4E]" />
                )}
              </div>
              <h3 className="font-serif text-2xl font-semibold text-[#1B4332] mb-2">
                {item.name}
              </h3>
              <p className="text-[#636E72] mb-4 line-clamp-2">
                {item.description}
              </p>
              <p className="font-bold text-xl text-[#C67C4E]">
                {item.price}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link to="/menu">
            <Button className="btn-primary text-lg px-8 py-4 h-auto">
              View Full Menu
              <ChevronRight size={20} className="ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MenuHighlights;
